// 说明: 旋转切换组件，两个元素之间切换，类似于轮播图
import React, { useRef, useEffect, useCallback } from 'react';
import { Animated, ViewStyle } from 'react-native';
import { KView } from '@/component/RtlLayout';

// 在线演示: https://snack.expo.dev/fpAr510UMitytLShQOnqJ

interface AnimatedRotateSwitchProps {
    duration?: number; // 切换动画时长
    delay?: number; // 停留时间
    style?: ViewStyle;
    children?: React.ReactNode[];
    // 其他属性
    [key: string]: any;
}

export function AnimatedRotateSwitch(props: AnimatedRotateSwitchProps) {
    const ElemOneRotate = useRef(new Animated.Value(0)).current;
    const ElemTwoRotate = useRef(new Animated.Value(90)).current;
    const [ElemOne, ElemTwo] = props.children;
    const { duration = 160, delay = 3000 } = props;
    const startAnimation = useCallback(() => {
        ElemOneRotate.setValue(0);
        ElemTwoRotate.setValue(90);
        Animated.loop(
            Animated.sequence([
                // 1消失 2出现
                Animated.timing(ElemOneRotate, {
                    toValue: 90,
                    duration: duration,
                    useNativeDriver: true,
                }),
                Animated.timing(ElemTwoRotate, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: true,
                }),
                Animated.delay(delay),
                // 2消失 1出现
                Animated.timing(ElemTwoRotate, {
                    toValue: 90,
                    duration: duration,
                    useNativeDriver: true,
                }),
                Animated.timing(ElemOneRotate, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: true,
                }),
                Animated.delay(delay),
            ])
        ).start();
    }, [ElemOneRotate, ElemTwoRotate, duration, delay]);

    useEffect(() => {
        // 开始动画
        startAnimation();
    }, [startAnimation]);

    return (
        <KView {...props}>
            <Animated.View
                style={{
                    transform: [
                        {
                            rotateY: ElemOneRotate.interpolate({
                                inputRange: [0, 360],
                                outputRange: ['0deg', '360deg'],
                            }),
                        },
                        {
                            // 没有这个会出现奇怪的效果 https://reactnative.cn/docs/animations#%E7%89%A2%E8%AE%B0%
                            perspective: 1000,
                        },
                    ],
                }}>
                {ElemOne}
            </Animated.View>
            <Animated.View
                style={{
                    position: 'absolute',
                    transform: [
                        {
                            rotateY: ElemTwoRotate.interpolate({
                                inputRange: [0, 360],
                                outputRange: ['0deg', '360deg'],
                            }),
                        },
                        {
                            perspective: 1000,
                        },
                    ],
                }}>
                {ElemTwo}
            </Animated.View>
        </KView>
    );
}

// 使用
// export default App = () => {
//     const item1 = (
//         <View style={{"height":"12.077294685990339rem","width":"12.077294685990339rem","backgroundColor":"#00ff00"}}>
//             <Text>asdasad</Text>
//         </View>
//     );
//     const item2 = (
//         <View style={{"height":"12.077294685990339rem","width":"12.077294685990339rem","backgroundColor":"#ff0000"}}>
//             <Text>asdasad</Text>
//         </View>
//     );
//     return (
//         <View>
//             <AnimatedRotateSwitch style={{"height":"12.077294685990339rem","width":"12.077294685990339rem"}}>
//                 {item1}
//                 {item2}
//             </AnimatedRotateSwitch>
//         </View>
//     );
// };
